<template>
    <div class="basic" style="margin-top: 30px;">
        <Form ref="formInline" :model="formInline" style="width: 100%" :rules="ruleInline" label-position="top"
            @on-validate="getvalidate">
           
           

            <!-- 赞助类型 -->
            <div class="basic-link " style="padding: 0 0  0 30px;" :class="[single == '已选择1' ? headCssData : '']">
                <FormItem label="">
                    <div style="display: flex; justify-content: space-between;" @click="sponsorSelect1()">
                        <p style="font-size: 18px;line-height: 48px;">Type of cooperation</p>
                        <p class="selectedStyle">
                            <RadioGroup v-model="single">
                                <Radio v-if="single == '已选择1'" label="已选择1">Selected</Radio>
                            </RadioGroup>
                        </p>
                    </div>
                </FormItem>
            </div>
            <div style="margin-bottom: 30px" :class="[single == '已选择1' ? footCssData : 'borderCss']"
                >
                <div style="padding: 30px 0 30px 30px;padding-top: 10px;">
                    <div class="tabs">
                        <div class="tabs-top">
                            <Row :gutter="24">
                                <Col span="6" v-for="(item, index) in listPavilion" :key="index"
                                    style="margin-top: 20px;">
                                <!-- <div class="tag" :class="{ active: areaIndex === index }"
                            @click="areaName = item.tname; areaIndex = index;getOrder(item)">
                            <span>{{ item.tname }}</span>
                        </div> -->
                                <Tooltip :content="item.text" placement="bottom" theme="light" style="max-width:1200px">
                                    <Button :disabled="item.tname == 'Chief'" @click="sponsorChange(item, index)" style="width: 260px;"
                                        :class="[sponsorValIndex == index ? 'borderCssButt' : '']">{{
                                            item.tname
                                        }}</Button>
                                    <div slot="content">
                                        <p>{{ item.text0 }}</p>
                                        <p>{{ item.text1 }}</p>
                                        <p>{{ item.text2 }}</p>
                                        <p>{{ item.text3 }}</p>
                                    </div>
                                </Tooltip>
                                </Col>
                                <!-- <p style="margin-top: 130px;font-size: 12px;color: #7f7f7f">(Gray option is sold out,
                                    not selectable)</p> -->
                            </Row>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 选择展区 -->
            <div class="basic-link" style="padding: 0 0  0 30px;" :class="[single == '已选择2' ? headCssData : '']">
                <FormItem label="">
                    <div style="display: flex; justify-content: space-between;" @click="sponsorSelect2()">
                        <p style="font-size: 18px;line-height: 48px;">Select an exhibition area</p>
                        <p class="selectedStyle">
                            <RadioGroup v-model="single">
                                <Radio v-if="single == '已选择2'" label="已选择2">Selected</Radio>
                            </RadioGroup>
                        </p>
                    </div>
                </FormItem>
            </div>
            <div style="margin-bottom: 30px" :class="[single == '已选择2' ? footCssData : 'borderCss']"
                >
                <div style="padding: 30px 0 10px 30px;padding-top: 30px;">
                    <Row :gutter="10">
                        <Col span="12">
                        <div style="display: flex">
                            <FormItem label="Select an exhibition area" prop="">
                                <!-- <Input type="text" placeholder="选择展区" v-model="formInline.linkMan"
                  style="width: 270px; margin-right: 10px" /> -->
                                <Select v-model="exVal" style="width:270px;margin-right: 10px"
                                    placeholder="Please select" @on-change="exValSelect">
                                    <Option v-for="item in exAreaList" :value="item.id" :key="item.id">{{
                                        item.name
                                    }}</Option>
                                </Select>
                                <p style="font-size: 12px;color:#808080;width: 1000px">Please select the corresponding
                                    exhibition area according to the industry of the company you entered</p>

                            </FormItem>
                            <FormItem label="" prop="" style="margin-left: -600px;display: flex; margin-top: 23px;">
                                <div style="display: flex;color:#333333 ">
                                    <div>
                                        <RadioGroup v-model="animal" style="width: 500px;"
                                            @on-change="exValSelect(exVal)">
                                            <Radio label="光地" :disabled="sponsorDis">Raw space: 2100/㎡ (from 18㎡)
                                            </Radio>
                                            <Radio label="标展" :disabled="sponsorDis">Standard Booth: 2300/㎡ (from 12㎡)
                                            </Radio>
                                        </RadioGroup>
                                    </div>
                                    <div style="display: flex;align-items: center;width: 200px;">
                                        Reserved area<InputNumber :max="99999999999" :min="1" v-model="value1"
                                            @on-change="areaInputChange" :disabled="sponsorDis"
                                            style="margin-left: 8px;" placeholder="">
                                        </InputNumber> ㎡
                                    </div>
                                </div>
                            </FormItem>
                        </div>
                        </Col>
                    </Row>
                </div>
            </div>


            <!-- 附件上传 -->
            <!-- <div class="basic-header">
                <p>Attachment upload </p>
            </div>
            <div style="border:solid 1px #e5e5e5;margin-bottom: 30px">
                <div class="basic-links">
                    <Row :gutter="10">
                        <Col span="12">
                        <FormItem label="License" required>
                            <div style="display: flex; position: relative">
                                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList"
                                    :on-success="handleSuccess" :format="['jpg', 'png']" :max-size="2048"
                                    :headers="formHeaders" :on-format-error="handleFormatError"
                                    :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload"
                                    :action="uploadUrl" style="margin-right: 10px">
                                    <div class="upload-btn">Upload your business license</div>
                                </Upload>
                                <p style="position: absolute;left: 0;top: 34px;font-size: 12px;color: #808080;">
                                    Support jpg, png, no more than 2M
                                </p>
                                <div class="license-img">
                                    <template v-if="uploadList && uploadList.length">
                                        <div class="license-img-list" v-for="(item, index) in uploadList"
                                            :key="'upload' + index">
                                            <template v-if="item.status === 'finished'">
                                                <span class="txt1" :title="item.name" v-if="item.name">{{
                                                    item.name.split('.')[0]
                                                }}</span>
                                                <span class="line"></span>
                                                <span @click="handleRemoveByArr(item)">Delete</span>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="LOGO" required>
                            <div style="display: flex; position: relative">
                                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList2"
                                    :on-success="handleSuccess2" :format="['jpg', 'png']" :max-size="2048"
                                    :headers="formHeaders" :on-format-error="handleFormatError2"
                                    :on-exceeded-size="handleMaxSize2" :before-upload="handleBeforeUpload2"
                                    :action="uploadUrl" style="margin-right: 10px">
                                    <div class="upload-btn">Upload the logo</div>
                                </Upload>
                                <p style="
                    position: absolute;
                    left: 0;
                    top: 34px;
                    font-size: 12px;
                    color: #808080;
                  ">
                                    Support jpg, png , no more than 2M
                                </p>
                                <div class="license-img">
                                    <template v-if="uploadList2 && uploadList2.length">
                                        <div class="license-img-list" v-for="(item, index) in uploadList2"
                                            :key="'upload' + index">
                                            <template v-if="item.status === 'finished'">
                                                <span class="txt1" :title="item.name" v-if="item.name">{{
                                                    item.name.split('.')[0]
                                                }}</span>
                                                <span class="line"></span>
                                                <span @click="handleRemoveByArr2(item)">Delete </span>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </FormItem>
                        </Col>
                    </Row>

                </div>
            </div> -->

            


        </Form>
    </div>
</template>

<script>
import mFormAddress from "@components/m-form/m-form-address-en.vue";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
export default {
    name: "register-form", // 参展申请 - 基本信息
    components: {
        mFormAddress,
    },
    data () {
        const that = this;
        const websiteValid = (rule, value, callback) => {
            if (value) {
                if (/(http|https):\/\/([\w.]+\/?)\S*/.test(value)) {
                    callback();
                } else {
                    callback("website format is not correct!");
                }
            } else {
                callback();
            }
        };
        // 判断英文
        const enValid = (rule, value, callback) => {
            if (!value) {
                callback();
            } else {
                if (/^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(value)) {
                    callback();
                } else {
                    callback(new Error('company name format is not correct!'));
                }
            }
        };
        const companyAddressValid = (rule, value, callback) => {
            // if (that.formInline.addresss.country && that.formInline.addresss.country === 'China') { // China 判断省份和城市是否选择
            //     if (!that.formInline.addresss.province) {
            //         callback(new Error('province is empty'));
            //     } else if (!that.formInline.addresss.city) {
            //         callback(new Error('city is empty'));
            //     } else {
            //         callback();
            //     }
            // } else {
            if (that.formInline.addresss.country) {
                callback();
            }
            // else {
            //     callback(new Error('Country/District is empty'));
            // }
            // }
        };
        const mobValid = (rule, value, callback) => {
            if (!that.tel.country) {
                callback(new Error('Country Code is empty'));
            } else if (!that.tel.area) {
                callback(new Error('Area Code is empty'));
            } else if (!that.tel.no) {
                callback(new Error('Area Code is empty'));
            } else {
                callback();
            }
        };
        const faxValid = (rule, value, callback) => {
            if (!that.fax.country) {
                callback(new Error('Country Code is empty'));
            } else if (!that.fax.area) {
                callback(new Error('Area Code is empty'));
            } else if (!that.fax.no) {
                callback(new Error('Area Code is empty'));
            } else {
                callback();
            }
        };
        const validEmail = (rule, value, callback) => {
            if (!value) {
                return false;
            } else if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
                return true;
            } else {
                return false;
            }
        };
        return {

            listPavilion: [
                // { tname: "Chief", text1: 'Price：1.9 million Yuan', text2: 'Area：180 square meters', text3: 'Other interests：Advertising, listing, media, speech and other exclusive services（Please call +86 15101626947 for details）' },
                // { tname: "Strategic Partner", text1: 'Price：1.4 million Yuan', text2: 'Area：180 square meters', text3: 'Other interests：Advertising, listing, media, speech and other services（Please call +86 15101626947 for details）' },
                // { tname: "Assisting Unit", text1: 'Price：1 million Yuan', text2: 'Area：150 square meters', text3: 'Other interests：Advertising, listing, media, speech and other services（Please call +86 15101626947 for details）' },
                // { tname: "Support Unit", text1: 'Price：1 million Yuan', text2: 'Area：150 square meters', text3: 'Other interests：Advertising, listing, media, speech and other services（Please call +86 15101626947 for details）' },
                // { tname: "Conors A", text1: 'Price：0.65 million Yuan', text2: 'Area：150 square meters', text3: 'Other interests：Advertising, listing, media, speech and other services（Please call +86 15101626947 for details）' },
                // { tname: "Conors B", text1: 'Price：0.33 million Yuan', text2: 'Area：120 square meters', text3: 'Other interests：Advertising, listing, media, speech and other services（Please call +86 15101626947 for details）' },
                // { tname: "General sponsorship", text1: 'Price：0.22 million Yuan', text2: 'Area：60 square meters', text3: 'Other interests：Advertising, listing, media, speech and other services（Please call +86 15101626947 for details）' },
                // { tname: "CHCC Hospital Construction Award", text1: 'CHCC Hospital Construction Award Strategic  Partner' },
                // { tname: "special forum Sponsorship", text1: 'Enterprise special forum (co-organized)/forum support unit' },
                // { tname: "Advertising Contribution", text1: 'Please call +86 15101626947 for detailed sales information.' },
                { tname: "Chief strategic cooperation",  text0: 'Quantity of cooperation: Exclusive',text1: 'Cooperation minimum price: 1.2million RMB', text2: 'Minimum booth area: 180 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' },
                { tname: "Strategic cooperation",  text0: 'Quantity of cooperation: limited to 2 companies',text1: 'Cooperation minimum price: 900,000 RMB',text2: 'Minimum booth area: 150 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc'  },
                { tname: "Assisting Unit",  text0: 'Quantity of cooperation: limited to 3 companies', text1: 'Cooperation minimum price: 600,000 RMB', text2: 'Minimum booth area: 120 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc'  },
                { tname: "Supporting units",   text0: 'Quantity of cooperation: limited to 15 companies',text1: 'Cooperation minimum price: 300,000 RMB', text2: 'Minimum booth area: 90 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media and other services, etc' },
                { tname: "Honorary Sponsorship",  text0: 'Quantity of cooperation: limited to 20 companies', text1: 'Cooperation minimum price: 200,000 RMB', text2: 'Minimum booth area: 60 square meters', text3: 'Other rights and interests: VIP booth, advertising and other services, etc'  },

                // { tname: "Raw space",  text0: '2100 RMB / ㎡, Minimum booth area ：18 ㎡, only a empty space' },
                // { tname: "Standard booth",  text0: '2300 RMB / ㎡, Minimum booth area ： 12 ㎡, including basic furniture, carpet, lighting, socket, lintel board'  },
                { tname: "Special Forum cooperation",  text0: 'Enterprise special forum (Assisting unit)/forum support companies）'  },

            ],


            loading: false,
            fax: {
                country: '',
                area: '',
                no: '',
            },
            tel: {
                country: '',
                area: '',
                no: '',
            },
            formInline: {
                // 企业基本信息
                linkFax: "",
                companyName: "", // 公司名称
                companyNameEn: "",// 公司Enterprise name
                companyNameShort: "",// 公司Enterprise name
                address: "", // address
                addresss: {
                    country: "China", // 国家
                    province: "", // 省份
                    city: "", // 城市
                    county: "", // 区县 
                },
                postcode: "",
                // 展会联系人
                linkMan: "",
                linkTitle: "",
                linkMob: "", // 电话号码 
                linkEmail: "",
                // 所属行业
                industry: "",
                highlightProducts: "",
            },
            formInline1: {
                // 企业基本信息
                linkFax: "",
                companyName: "上海789术有限公司", // 公司名称
                companyNameEn: "lianzohn",// 公司Enterprise name
                companyNameShort: "lia444nzhan",// 公司Enterprise name
                address: "金沙江西路1555路慧创国际16号2层", // address
                addresss: {
                    country: "China", // 国家
                    province: "Beijing", // 省份
                    city: "Xicheng", // 城市
                    county: "", // 区县 
                },
                postcode: "201803",

                // 展会联系人
                linkMan: "momo",
                linkTitle: "技术",
                linkMob: "13122959676",
                linkEmail: "2624006658@qq.com",
                // 所属行业
                industry: "1",
                highlightProducts: "chanpin",
            },
            ruleInline: {
                // 企业基本信息
                companyNameEn: [
                    { required: true, message: "Please enter the Enterprise name", trigger: "blur" },
                    { validator: enValid, trigger: "blur" }
                ],
                companyNameShort: [{ required: true, message: "Please enter the abbreviation (2~4 words)", trigger: "blur" }],

                website: [
                    { required: true, message: "Please enter the website", trigger: "blur" },
                    { validator: websiteValid, trigger: "blur" }
                ],
                postcode: [{ required: true, message: "Please enter the postal code", trigger: "blur" }],
                addresss: [{
                    required: true,
                    validator: companyAddressValid, trigger: "blur"
                }],
                linkTelephone: [{
                    required: true,
                    validator: mobValid, trigger: "blur"
                }],
                Fax: [{
                    required: true,
                    validator: faxValid, trigger: "blur"
                }],
                address: [
                    { required: true, message: "Please enter the address", trigger: "blur" },
                ],

                // 展会联系人
                linkMan: [{ required: true, message: "Please enter the name", trigger: "blur" }],
                linkTitle: [{ required: true, message: "Please enter the position", trigger: "blur" }],
                linkMob: [
                    {
                        required: true,
                        message: "Please enter the phone",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback('Please enter the phone');
                            } else if (/^[1][0-9]{10}$/.test(value)) {
                                callback();
                            } else {
                                callback('Phone format is not correct!');
                            }
                        }, trigger: "blur"
                    }
                ],
                // linkEmail: [
                //     // { required: true, message: 'Please enter the Mailbox', trigger: 'blur' },
                //     {
                //         validator: validEmail, message: 'Mailbox format is not correct!', trigger: "blur"
                //     }
                // ],
                // 所属行业
                industry: [{ required: true, message: "Please select", trigger: "change" }],
                highlightProducts: [{ required: true, message: "Product name", trigger: "blur" }],
            },
            defaultList: [],
            uploadList: [],
            uploadName: "",
            defaultList2: [],
            uploadList2: [],
            uploadName2: "",


            validateList: [],

            countryList: [],
            provinceArr: [],
            citiesArr: [],
            single: '',
            headCssData: 'headCss',
            footCssData: 'footCss',
            value: 0,
            sponsorVal: "",
            exVal: "",
            areaName: "",
            sponsorValIndex: 20,
            value1: 0,
            animal: '标展',
            cityList: [],
            exAreaList: [],
            sponsorDis: true,
            transferList: [],
        };
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            exhibitionId: "getExhibitionId",
            company: "getCompany",
        }),
    },
    created () {
    },
    mounted () {
        this.initExArea()
        this.initAllHy()
    },
    methods: {
        ...mapActions({
            getAllExArea: "releaseModule/getAllExArea", //获取展区和订单
            getAllHy: "releaseModule/getAllHy", //获取展区和订单

            getCityByParentId: "exhibitionModule/getCityByParentId",
            addApplyCompany: "addApplyCompany",
            editApplyCompany: "editApplyCompany",
        }),

        async initExArea () {
            let opt = {
                clientId: "23",
                languageType: "英文"
            };
            this.exAreaList = await this.getAllExArea(opt);
        },
        // 行业
        async initAllHy () {
            let opt = {
                groupId: "11"
            };
            this.cityList = await this.getAllHy(opt);
        },

        getvalidate (prop, status, error) {
            if (status == false) {
                let opt = {
                    prop: prop,
                    status: status,
                };
                this.validateList.push(opt);
            }
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    console.log(valid, "valid");
                    resolve(valid);
                });
            });
        },



        handleSuccess (res, file) {
            if (res && res.list.length) {
                file.url = res.list[0];
                this.uploadList.push({
                    name: this.uploadName,
                    url: res.list[0],
                    status: "finished",
                });
            } else {
                this.uploadName = "";
            }
        },
        handleFormatError (file) {
            this.uploadName = "";
            this.$Notice.warning({
                title: "The file format is incorrect",
                desc: "Please upload pictures in jpg or png format",
            });
        },
        handleMaxSize (file) {
            this.uploadName = "";
            this.$Notice.warning({
                title: "File size exceeds the limit",
                desc: "Please upload pictures smaller than 2M",
            });
        },
        handleBeforeUpload (e) {
            this.uploadName = e.name;
            const limitNum = 1;
            const check = this.uploadList.length < limitNum;
            if (!check) {
                this.$Notice.warning({
                    title: `Upload at most${limitNum}Pictures`,
                });
            }
            return check;
        },
        handleRemoveByArr (file) {
            const fileList = this.uploadList;
            this.uploadList.splice(fileList.indexOf(file), 1);
        },

        handleSuccess2 (res, file) {
            if (res && res.list.length) {
                file.url = res.list[0];
                this.uploadList2.push({
                    name: this.uploadName2,
                    url: res.list[0],
                    status: "finished",
                });
            } else {
                this.uploadName2 = "";
            }
        },
        handleFormatError2 (file) {
            this.uploadName2 = "";
            this.$Notice.warning({
                title: "The file format is incorrect",
                desc: "Please upload pictures in jpg or png format",
            });
        },

        handleMaxSize2 (file) {
            this.uploadName2 = "";
            this.$Notice.warning({
                title: "File size exceeds the limit",
                desc: "Please upload pictures smaller than 2M",

            });
        },
        handleBeforeUpload2 (e) {
            this.uploadName2 = e.name;
            const limitNum = 1;
            const check = this.uploadList2.length < limitNum;
            if (!check) {
                this.$Notice.warning({
                    title: `Upload at most${limitNum}Pictures`,
                });
            }
            return check;
        },
        handleRemoveByArr2 (file) {
            const fileList = this.uploadList2;
            this.uploadList2.splice(fileList.indexOf(file), 1);
        },


        // 选择赞助类型
        sponsorChange (e, index) {
            this.sponsorVal = e.tname
            this.sponsorValIndex = index

           
            this.transferList = []
            let order = {}
            order.areaName = e.tname //订单名称
            order.areaType = '标展' //展区（订单）类别
            order.pType = 'RMB' //币种
            order.showArea = 1	//预定面积
            this.transferList.push(order)

            this.single = '已选择1'
            // this.exAreaList.map(i => {
            //     if (i.name == 'VIP Exhibition Area') {
            //         this.exVal = i.id
            //         i.pjNames.map(j => {
            //             if (j.pjName.indexOf(e.tname) != -1) {
            //             // if (j.pjName == e.tname) {
            //                 order.hallCount = 1 //展位数量
            //                 order.pType = j.pType //币种
            //                 order.showArea = j.standstall	//预定面积
            //                 order.allMoney = j.price	//总价
            //                 order.ApplyBoothOrder = {
            //                     boothType: j.boothType,
            //                     unit: j.cunit,
            //                     dePjNameGroupId: i.id,
            //                     gpName: j.gpName,
            //                     groupId: j.groupId,
            //                     dePjNameGroupName: i.name,
            //                     pjCode: j.pjCode,
            //                     pjFormat: j.pjFormat,
            //                     unitPrice: j.price,
            //                     monetaryUnit: j.pType,
            //                     name: j.pjName,
            //                     area: j.standstall,
            //                 }

            //             // }
            //             }
            //         })
            //     }
            // })

          

        },
        areaInputChange (e) {
            this.single = '已选择2'
            this.sponsorValIndex=20
            if (this.exVal) {
                this.transferList[0].showArea = e
                this.transferList[0].hallCount = e
                this.transferList[0].applyBoothOrder.area = e
            } else {
                this.value1 = e
            }

        },
        exValSelect (e) {
            this.single = '已选择2'
            this.sponsorValIndex=20
            this.sponsorDis = false
            this.transferList = []
            let order = {}

            this.exAreaList.map(i => {
                if (i.id == e) {
                    i.pjNames.map(j => {
                        if (j.boothType == this.animal) {
                            this.value1 = j.standstall
                            order.hallCount = 1 //展位数量
                            order.pType = j.pType //币种
                            order.showArea = this.value1	//预定面积
                            order.allMoney = j.price	//总价
                            order.applyBoothOrder = {
                                boothType: j.boothType,
                                unit: j.cunit,
                                dePjNameGroupId: i.id,
                                gpName: j.gpName,
                                groupId: j.groupId,
                                dePjNameGroupName: i.name,
                                pjCode: j.pjCode,
                                pjFormat: j.pjFormat,
                                unitPrice: j.price,
                                monetaryUnit: j.pType,
                                name: j.pjName,
                                area: this.value1
                            }

                        }
                    })
                }
            })
            this.transferList.push(order)

        },
 //校验邮箱格式
 checkEmail (email) {
            return RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(email)
        },

        async handleSubmit (name) {
            // let form = this.formInline;
            // let valid = await this.validForm('formInline');
            if (this.formInline.linkEmail) {
                if (!this.checkEmail(this.formInline.linkEmail)) {
                    this.$Message.error('Please fill in the correct email');
                    return
                }
            }
            // // 营业执照
            // let imgBusinessLicense = "";
            // let imgBusinessLicense2 = "";
            // if (this.uploadList && this.uploadList.length) {
            //     imgBusinessLicense = this.uploadList[0];
            // } else {
            //     this.$Message.error('Please upload your business license');
            //     valid = false;
            //     return
            // }
            // if (this.uploadList2 && this.uploadList2.length) {
            //     imgBusinessLicense2 = this.uploadList2[0];
            // } else {
            //     this.$Message.error('Please upload the company logo');
            //     valid = false;
            //     return
            // }

           
            // console.log('form', this.formInline);
            // let formValue = {
            //     // linkFax: `${this.fax.country || ''}${this.fax.area || ''}${this.fax.no || ''}`,
            //     companyName: form.companyNameEn, // 公司名称
            //     companyNameShort: form.companyNameShort,// 公司Enterprise name
            //     address: form.address, // address 
            //     country: form.addresss.country,
            //     province: form.addresss.province,
            //     city: form.addresss.city,
            //     county: form.addresss.county,

            //     // 展会联系人
            //     linkMan: form.linkMan,
            //     linkTitle: form.linkTitle,
            //     linkTelephone: form.linkMob,
            //     linkEmail: form.linkEmail,

            //     typeBusiness: form.industry,
            //     productName: form.highlightProducts,

            //     supportType: this.sponsorVal,//赞助类型


            //     // imgBusinessLicense: JSON.stringify(imgBusinessLicense),
            //     // imgLogo: JSON.stringify( imgBusinessLicense2 ),
            // }
            // if (!valid) {
            //     this.$Message.error("Errors in forms submitted, please re-submit.");
            //     return
            // }
                //   展位预定信息
             
                if (this.single == '已选择1') {
                    if (!this.sponsorVal) {
                        this.$Message.error('Please select the cooperation Level');
                        return
                    }
                }
                if (this.single == '已选择2') {
                    if (!this.exVal) {
                        this.$Message.error('Please select exhibition area');
                        return
                    }
                    if (!this.exVal) {
                        this.$Message.error('Please select exhibition area');
                        return
                    }
                    if (!this.animal) {
                        this.$Message.error('Please select light ground/standard exhibition');
                        return
                    }
                }

                if(this.single=='已选择2'){
                    this.transferList = []
                    let order = {}
                    order.areaName = this.exVal //订单名称
                    order.areaType = this.animal //展区（订单）类别
                    order.pType = 'RMB' //币种
                    order.showArea = this.value1	//预定面积
                    this.transferList.push(order)
                    console.log(  this.transferList);
                }

            return new Promise((resolve, reject) => {
                resolve({  lists: this.transferList, })
            });
        },
        validAddresss () {
            this.$refs['formInline'].validateField('addresss', (valid) => {
                console.log("addresss", valid);
            });
        },
        // 选择战区
        sponsorSelect1 () {
            if(this.single == '已选择1'){
                this.single = ''
            }else{

                this.single = '已选择1'
            }
            // this.single = '已选择1'
            this.animal = ''
            this.value1 = 0
            this.sponsorDis = true
        },
        sponsorSelect2 () {
            if(this.single == '已选择2'){
                this.single = ''
            }else{

                this.single = '已选择2'
            }
                // this.single = '已选择2'
            this.sponsorDis = false
            this.sponsorVal = ''
            this.sponsorValIndex = 20
        },

    },
};
</script>

<style scoped lang='scss'>
.basic {
    /deep/ {
        .ivu-checkbox-checked .ivu-checkbox-inner {
            border-color: #1e88e5;
            background-color: #1e88e5;
        }

        .ivu-upload-select {
            display: flex;
        }

        .ivu-radio-checked .ivu-radio-inner {
            border-color: #1e88e5 !important;
        }

        .ivu-radio-inner:after {
            background-color: #1e88e5;
        }

        .ivu-switch-checked {
            border-color: #1e88e5;
            background-color: #1e88e5;
        }
    }

    &-header {
        width: 100%;
        height: 64px;
        background-color: #1e88e5;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
            line-height: 64px;
            font-size: 20px;
        }

        span {
            width: 30px;
            height: 1px;
            background-color: #fff;
            margin: 0 15px;
        }
    }

    &-name {
        padding: 30px 30px 10px 30px;
        background-color: #fff;
    }

    &-address {
        padding: 30px 30px 10px 30px;
        background-color: #ededed;
    }

    &-phone {
        padding: 30px 30px 10px 30px;
        background-color: #fff;
    }

    &-license {
        padding: 30px 30px 10px 30px;
        background-color: #ededed;
    }


    .upload-btn {
        width: 190px;
        height: 32px;
        text-align: center;
        cursor: pointer;
        background-color: #f5f5f5;
        border: 1px dotted #bfbfbf;
    }

    .license-img {
        display: flex;
        flex-wrap: wrap;

        &-list {
            line-height: 32px;
            padding: 0 10px;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            margin-right: 10px;
            margin-bottom: 10px;

            .txt1 {
                width: 200px;
                display: inline-block;
                height: 32px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #515a6e !important;
            }

            span {
                color: #ff0011;
                cursor: pointer;
            }

            .line {
                width: 1px;
                height: 24px;
                background-color: #e6e6e6;
                margin: 0 6px;
            }
        }
    }

    &-export {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-scale {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    &-tech {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-link {
        padding: 0 30px;
        background-color: #ededed;

        .ivu-form-item {
            margin-bottom: 0;
            line-height: 48px;

            /deep/ .ivu-form-item-label {
                font-size: 18px;
                padding: 0;
            }
        }
    }

    &-links {
        padding: 30px 30px 10px 30px;
        background-color: #fff;
    }

    &-leader {
        padding: 0 30px;
        background-color: #ededed;
        position: relative;

        .ivu-form-item {
            margin-bottom: 0;
            line-height: 48px;

            /deep/ .ivu-form-item-label {
                font-size: 18px;
                padding: 0;
            }
        }

        .above {
            position: absolute;
            left: 240px;
            top: 10px;
        }
    }

    &-leaders {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-invoiceType {
        padding: 0 30px;
        background-color: #ededed;
        line-height: 48px;
        display: flex;
        justify-content: space-between;

        .ivu-checkbox-wrapper {
            margin: 0;
        }

        span {
            color: #ff0000;
            margin-left: 5px;
        }
    }

    &-invoices {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }
}

/deep/ .ivu-tooltip-inner {
    max-width: 1200px;
}

// 已选择的样式
.selectedStyle {
    line-height: 48px;
    width: 100px;
    color: #1e88e5;
    text-align: center;
    border-bottom-left-radius: 20px;
    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    font-weight: 900;
}

.headCss {
    border-top: solid 1px #1e88e5;
    border-left: solid 1px #1e88e5;
    border-right: solid 1px #1e88e5;
    background: #E8F3FC;
}

.footCss {
    border-bottom: solid 1px #1e88e5;
    border-left: solid 1px #1e88e5;
    border-right: solid 1px #1e88e5;
    // background-color: rgba(35, 87, 205, 0.2)
}

.borderCss {
    border: 1px solid #e5e5e5
}

.borderCssButt {
    border: 1px solid #1e88e5;
    color: #1e88e5;
}
</style>
